import React from "react";
import Link from "@helpers/link";
import addImageDimensions from "@root/utils/addImageDimensions";

let ThreeDEngineReadyIDs = [516,723,655,240,662,243,244,246,653,248,249,651,650,254,255,663,648,647,646,275,637,635,634,633,677,629,628,848,846,622,312,314,616,699,809,598,800,593,335,336,337,717,721,574,780,774,767,765,763,761,759,757,755,753,751,750,748,572,359,570,569,740,738,736,734,731,727,725,601,847,624,594,627,645,580,682,340,250,252,703,705,711,666,713,626,642,643,644,623,621,242,631,341,263,361,265,264,278,235,261,233,260,258,232,238,236,234,283,267,302,268];
let showThreeDEngineReady = false;

const ProductGrid = ({ items, productRefs, onClick }) => {
    if (!items) return null;

    return (
        <div className="product-grid">
            <div className="product-grid__inner">
                {items.map((item, index) => (
                    <div
                        key={item?.id}
                        className={`product-grid__item ${ThreeDEngineReadyIDs.includes(item?.id) && showThreeDEngineReady ? 'product-grid__item--three-d-engine-ready' : ''}`}
                        data-category-id={item?.category?.id}
                        /* eslint-disable no-param-reassign */
                        ref={(element) => {
                            if (productRefs?.current) {
                                productRefs.current[index] = element;
                            }
                            return null;
                        }}
                        /* eslint-enable no-param-reassign */
                    >
                        <Link to={item?.url} onClick={(e) => onClick(e, item)}>
                            <div className="product-grid__item-wrapper">
                                <div className="product-grid__item-image-wrapper">
                                    <div className="product-grid__item-image-ratio">
                                        {item?.image ? <img className="product-grid__item-image" src={addImageDimensions(item?.image, 600)} alt={item?.alt} /> : ''}
                                        <div className="product-grid__item-details">
                                            <div className="product-grid__item-details-url">
                                                Details
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="product-grid__item-content">
                                    <div className="product-grid__item-title">
                                        {item?.title && (
                                            <>
                                                <div className="product-grid__item-title-name">{item.title.split(" - ")[0]}</div>
                                                {item.title.split(" - ")[1] && (<div className="product-grid__item-title-model">{item.title.split(" - ")[1]}</div>)}
                                            </>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </Link>
                    </div>
                ))}

            </div>
        </div>
    );
};

export default ProductGrid;
